import React from 'react'
import { observer } from 'mobx-react'
import styles from './DocumentsEmptyState.sass'
import { EmptyState, EmptyStateIllustrationImage } from 'components/EmptyState'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import Workspace from 'iam/models/Workspace'
import FileButton from 'components/FileButton'

interface Props {
  currentWorkspaceEmpty: boolean
  currentWorkspace: Workspace
  onSelectCurrentWorkspace: () => void
  onQueueFilesUpload: (files: FileList) => void
}

export default observer(function DocumentsEmptyState({
  currentWorkspaceEmpty,
  currentWorkspace,
  onSelectCurrentWorkspace,
  onQueueFilesUpload,
}: Props) {
  const { corporateMode } = useBrandingSettings()

  return (
    <div className={styles.emptyStateContainer}>
      {currentWorkspaceEmpty ? (
        <EmptyState
          className={styles.emptyState}
          hideIllustration={corporateMode}
          image={
            <EmptyStateIllustrationImage
              src={require('assets/images/img_nojobstodisplay.svg')}
            />
          }
          title="You haven't uploaded any files yet"
          subtitle="You can use this screen to upload images and documents for ease of access. Simply drag and drop or click Upload Files to get started"
          animate
        >
          <FileButton
            multiple={true}
            onChange={onQueueFilesUpload}
            data-test="upload-document-input-classic"
          >
            <Button type="primary">Upload Files</Button>
          </FileButton>
        </EmptyState>
      ) : (
        <div className={styles.emptyStateContainer}>
          <EmptyState
            className={styles.emptyState}
            hideIllustration={corporateMode}
            image={
              <EmptyStateIllustrationImage
                src={require('assets/images/img_nojobstodisplay.svg')}
              />
            }
            title="You don't have any files in any workspace!"
            subtitle={`You can switch back to ${currentWorkspace.name} and upload a file or select another workspace in the workspace switcher`}
            animate
          >
            <Button onClick={onSelectCurrentWorkspace} type="primary">
              View {currentWorkspace.name} Documents
            </Button>
          </EmptyState>
        </div>
      )}
    </div>
  )
})
